import { InjectionToken } from '@angular/core';
import { AlertService } from '@shared/services/alert.service';

export const MODAL_ALERT_SERVICE = new InjectionToken<AlertService>(
  'modal.alert',
);
